import { render, staticRenderFns } from "./hardwareVideo.vue?vue&type=template&id=57d1baf4&scoped=true&"
import script from "./hardwareVideo.vue?vue&type=script&lang=js&"
export * from "./hardwareVideo.vue?vue&type=script&lang=js&"
import style0 from "./hardwareVideo.vue?vue&type=style&index=0&id=57d1baf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d1baf4",
  null
  
)

export default component.exports